var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 44 125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 29.308,
    y1: 20.687,
    x2: 38.105,
    y2: 20.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--main-brand-gradient-start, #4701bc)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--main-brand-gradient-end, #df0552)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 29.309,
    y1: 104.854,
    x2: 38.103,
    y2: 104.854,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0,
    y1: 62.5,
    x2: 44,
    y2: 62.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--main-brand-gradient-start, #4701bc)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--main-brand-gradient-end, #df0552)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "line-gradient",
    stroke: "url(#a)",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 2.5,
    d: "M36.873 2.187l-6.333 37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#b)",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 2.5,
    d: "M30.54 87.187l6.333 35.333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.281 2.5c.986 0 4.11.652 5.997 1.111 2.618.655 5.537 2.632 5.196 6.057l-3.832 22.533a2.235 2.235 0 00-.02.143c-.308 2.772-2.656 4.863-5.461 4.863-.178 0-.358-.009-.536-.026l-8.843-1.606a3.795 3.795 0 00-.584-.047c-.998 0-1.936.389-2.641 1.097a3.682 3.682 0 00-1.087 2.608l-.201 23.291.201 23.22a3.698 3.698 0 001.087 2.636 3.705 3.705 0 003.225 1.048l8.843-1.606c.179-.017.359-.026.537-.026 2.805 0 5.153 2.09 5.461 4.863.005.048.012.096.02.143l3.832 22.533c.341 3.425-2.578 5.402-5.18 6.053-1.902.463-5.024 1.114-6.012 1.114h-.282c-15.163 0-27.499-12.263-27.499-27.336v-65.33C2.5 14.763 14.836 2.5 29.999 2.5h.281m.001-2.5h-.282C13.431 0 0 13.358 0 29.836v65.328C0 111.642 13.431 125 29.999 125h.282c1.732 0 6.603-1.185 6.603-1.185 4.369-1.093 7.552-4.454 7.067-8.824l-3.845-22.61c-.453-4.073-3.919-7.087-7.945-7.087-.294 0-.59.016-.889.049l-8.938 1.624a1.226 1.226 0 01-1.365-1.218l-.201-23.248.201-23.248a1.227 1.227 0 011.365-1.218l8.938 1.624c.298.033.595.049.889.049 4.027 0 7.493-3.014 7.946-7.086l3.845-22.61c.485-4.37-2.698-7.731-7.067-8.824C36.884 1.185 32.013 0 30.281 0z",
    fill: "url(#c)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerSupport);
export default __webpack_public_path__ + "static/media/customerSupport.4334d3b06dd893fcee621a60bec4bc27.svg";
export { ForwardRef as ReactComponent };